import React, { useEffect, useRef, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import AiLeadsAction from "../../Components/AiLeads/AiLeadsButton/AiLeadsAction";
import BRETable from "../../Components/BREComponent/BRETable/BRETable";
import { APIUrlThree, APIUrlToken, GetUserId } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import AddToFavoriteOrgModal from "../../Components/FavoritesList/AddToFavoriteModal/AddToFavoriteOrgModal";
import LeadsProspectModal from "../../Components/RequestUpdateModals/LeadsProspectModal";
import { Box, Modal } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import Loader from "../../Components/Loader/Loader";
import MessageModal from "../../Components/MessageModal/MessageModal";
import BrePdfAllTabs from "../../Components/BREComponent/BRETable/BrePdfAllTabs";
import html2pdf from "html2pdf.js";
const BusinessRE = () => {
  const [selectedOuterRows, setSelectedOuterRows] = useState([]);
  const selectedData = selectedOuterRows?.[0];
  const [breTableData, setBreTableData] = useState([]);
  const [skip, setSkip] = useState(0);
  const [showLoadMore, setShowLoadMore] = useState(false);
  const [downloadToPDF, setDownloadToPDF] = useState(false);
  const [trackRecord, setTrackRecord] = useState(false);
  const [messageModalTrack, setMessageModalTrack] = React.useState(false);
  const [trackingData, setTrackingData] = useState([]);
  const [requestUpdateRecord, setRequestUpdateRecord] = useState(false);
  const [disableRequestUpdate, setDisableRequestUpdate] = useState(false);
  const [addToFav, setAddToFav] = useState(false);
  const [shareRecord, setShareRecord] = useState(false);
  const [disableTracking, setDisableTracking] = useState(false);
  const [openCreateListmdl, setOpenCreateListmdl] = React.useState(false);
  const [requestUpdateModal, setRequestUpdateModal] = React.useState(false);
  const [requestUpdateData, setRequestUpdateData] = React.useState();
  const [loading, setLoading] = React.useState(false);
  const [successModel, setSuccessModel] = useState("");
  const [expandedRowId, setExpandedRowId] = useState(null);
  const [locationTableData, setLocationTableData] = useState({});
  const [financialTableData, setFinancialTableData] = useState({});
  const [PDFSelectedData, setPDFSelectedData] = useState([]);
  const [value, setValue] = React.useState(0);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "8px",
  };
  const breJoiData = (e) => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/bre_joi?limit=50&skip=${e === 1 ? 0 : skip * 50}`,
    };
    axios(option)
      .then((response) => {
        if (e === 1) {
          setSkip(0);
          setBreTableData([...response?.data?.data]);
        } else {
          setBreTableData((prev) => [...prev, ...response?.data?.data]);
        }
        setLoading(false);
        setShowLoadMore(true);
      })
      .catch(() => {
        setShowLoadMore(false);
        setLoading(false);
      });
  };
  useEffect(() => {
    breJoiData();
  }, [skip]);
  // Add to Favorites
  React.useEffect(() => {
    if (addToFav == true) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to Add To Favorites");
        setAddToFav(false);
        return;
      }
      setOpenCreateListmdl(true);
      setAddToFav(false);
    }
  }, [addToFav]);
  //Share Record
  React.useEffect(() => {
    if (shareRecord) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to share");
        setShareRecord(false);
        return;
      }
      handleShare();
    }
  }, [shareRecord]);
  const handleShare = () => {
    let start = window.location.origin;
    let end = window.location.pathname;
    let href = `${start}${end}`;
    const subject = encodeURIComponent("Link to BRE Company(ies)");
    let companiesInfo = selectedOuterRows
      .map((row) => {
        const name = row?.org_name
          ?.split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
        return `- Company: ${name}`;
      })
      .join("\n");
    const body = encodeURIComponent(
      `Hello,\n\nHere's a list of Company(ies) identified for Retention/Expansion in JOI that you may find interesting:\n${companiesInfo}\n\nTo view it, log into your JOI account and navigate to BRE: ${href}`,
    );
    const gmailLink = `https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=&su=${subject}&body=${body}`;
    window.open(gmailLink, "_blank");
    setSelectedOuterRows([]);
    setShareRecord(false);
  };
  // Request Update
  React.useEffect(() => {
    const handleRequestUpdate = async () => {
      if (requestUpdateRecord) {
        if (selectedOuterRows?.length < 1) {
          setDisableRequestUpdate(false);
          setRequestUpdateRecord(false);
          setRequestUpdateData();
          toast.error("Please select record to request update");
          return;
        }
        if (selectedOuterRows?.length === 1) {
          let orgData = await getOrgDescription(selectedOuterRows[0]?.org_id);
          setRequestUpdateData(orgData);
          setRequestUpdateModal(true);
          setRequestUpdateRecord(false);
          setDisableRequestUpdate(false);
          return;
        }
        if (selectedOuterRows?.length > 1) {
          setRequestUpdateData();
          setDisableRequestUpdate(false);
          setRequestUpdateRecord(false);
          toast.error("Please select only one record to request update");
          return;
        }
      } else {
        setDisableRequestUpdate(false);
        setRequestUpdateData();
      }
    };
    handleRequestUpdate();
  }, [selectedOuterRows, requestUpdateRecord]);
  const getOrgDescription = async (id) => {
    setLoading(true);
    try {
      const option = {
        method: "GET",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        url: `${APIUrlThree()}/v1/get_org_description?org_id=${id}`,
      };
      const response = await axios(option);
      if (response?.status === 200) {
        setLoading(false);
        return response?.data?.data[0];
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching org description:", error);
    }
    return null;
  };
  React.useEffect(() => {
    if (trackRecord == true) {
      if (!selectedOuterRows?.length) {
        toast.error("Please select records to track");
        setTrackRecord(false);
        return;
      } else {
        setMessageModalTrack(true);
        handleTrackingdata();
        setTrackRecord(false);
      }
    }
  }, [trackRecord]);
  const handleTrackRecords = () => {
    if (!selectedOuterRows?.length) {
      toast.error("Please select records to track");
      setTrackRecord(false);
      return;
    } else {
      setLoading(true);
      const filteredData = selectedOuterRows.filter(
        (selectedItem) =>
          !trackingData.some(
            (trackingItem) =>
              Number(selectedItem.org_id) === Number(trackingItem.org_id),
          ),
      );
      if (filteredData.length === 0) {
        toast.error("All selected records are already tracked.");
        setLoading(false);
        return;
      }
      const data = filteredData.map((item) => item?.org_id);
      const option = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken(),
        },
        data: data,
        url: `${APIUrlThree()}/v1/save_tracking_organization?user_id=${Number(GetUserId())}`,
      };
      axios(option)
        .then((response) => {
          if (response.status === 200) {
            setLoading(false);
            toast.success("Tracking Added");
            setTrackRecord(false);
            setMessageModalTrack(false);
            setSelectedOuterRows([]);
            setDisableTracking(true);
            handleTrackingdata();
          }
        })
        .catch((error) => {
          setLoading(false);
          toast.error(error.response.data.message);
        });
    }
  };
  const handleTrackingdata = () => {
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/get_tracking?user_id=${Number(GetUserId())}`,
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = e?.data?.data;
        setTrackingData(data);
      })
      .catch((err) => {});
  };
  const breLocationData = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/bre_locations/{id}?bre_organization_id=${expandedRowId?.bre_organization_id}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setLocationTableData(response?.data?.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const breFinancialData = () => {
    setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        "X-API-Key": APIUrlToken(),
      },
      url: `${APIUrlThree()}/v1/bre_financial_summary/{id}?bre_organization_id=${expandedRowId?.bre_organization_id}`,
    };
    axios(option)
      .then((response) => {
        setLoading(false);
        setFinancialTableData(response?.data?.data);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const breLocationDataPdf = async (ids) => {
    try {
      const option = {
        method: "GET",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        url: `${APIUrlThree()}/v1/bre_locations/{id}?bre_organization_id=${ids}`,
      };
      const response = await axios(option);
      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching location data for breId:", ids);
    }
  };
  const breFinancialDataPdf = async (ids) => {
    try {
      const option = {
        method: "GET",
        headers: {
          "access-control-allow-origin": "*",
          "content-type": "application/json",
          "X-API-Key": APIUrlToken(),
        },
        url: `${APIUrlThree()}/v1/bre_financial_summary/{id}?bre_organization_id=${ids}`,
      };
      const response = await axios(option);
      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching financial data for breId:", ids);
    }
  };
  const getNewsPdf = async (ids) => {
    try {
      const options = {
        method: "POST",
        headers: {
          "access-control-allow-origin": "*",
          "X-API-Key": APIUrlToken(),
        },
        url: `${APIUrlThree()}/v1/get_bre_request_news?sort_order=desc&request_type=bre_request&org_id=${ids}&limit=20&skip=0`,
      };
      const response = await axios(options);
      return response?.data?.data;
    } catch (error) {
      console.error("Error fetching financial data for breId:", ids);
    }
  };
  const contentRef = useRef();
  useEffect(() => {
    if (downloadToPDF === true && selectedOuterRows?.length) {
      setLoading(true);
      setTimeout(() => {
        generateHomeRowsPdf();
      }, 3000);
    } else if (downloadToPDF === true) {
      setLoading(true);
      setTimeout(() => {
        generateHomePdf();
      }, 3000);
    } else {
      setPDFSelectedData([]);
    }
  }, [downloadToPDF]);
  const generateHomeRowsPdf = async () => {
    const dataPromises = selectedOuterRows?.map(async (i) => {
      const locationData = await breLocationDataPdf(i?.bre_organization_id);
      const financialData = await breFinancialDataPdf(i?.bre_organization_id);
      const newsData = await getNewsPdf(i?.org_id);
      return { ld: locationData, fd: financialData, od: i, nd: newsData };
    });
    const data = await Promise.all(dataPromises);
    setPDFSelectedData(data);
  };
  const generateHomePdf = () => {
    const content = contentRef.current;
    const options = {
      filename: "BREData.pdf",
      margin: 5,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: {
        format: "letter",
        orientation: "landscape",
      },
    };
    html2pdf()
      .set(options)
      .from(content)
      .save()
      .then(() => {
        setDownloadToPDF(false);
        setLoading(false);
      })
      .catch(() => {
        setDownloadToPDF(false);
        setLoading(false);
      });
  };
  useEffect(() => {
    if (
      PDFSelectedData?.length &&
      PDFSelectedData?.length === selectedOuterRows?.length
    ) {
      generateHomePdf();
      setPDFSelectedData([]);
      setSelectedOuterRows([]);
    }
  }, [PDFSelectedData]);

  const [isTabletView, setIsTabletView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsTabletView(width >= 768 && width <= 1024);
    };

    handleResize(); // initial check
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>
      {loading ? <Loader /> : null}

      <Layout>
        {!isTabletView ? (
          <div className="child-section-of-everypage">
            <AiLeadsAction
              setDownloadToPDF={setDownloadToPDF}
              setTrackRecord={setTrackRecord}
              disableTracking={disableTracking}
              disableRequestUpdate={disableRequestUpdate}
              setRequestUpdateRecord={setRequestUpdateRecord}
              setAddToFav={setAddToFav}
              setShareRecord={setShareRecord}
            />
            <div style={{ marginTop: "70px" }}>
              <BRETable
                selectedOuterRows={selectedOuterRows}
                setSelectedOuterRows={setSelectedOuterRows}
                breTableData={breTableData}
                setBreTableData={setBreTableData}
                skip={skip}
                setSkip={setSkip}
                showLoadMore={showLoadMore}
                downloadToPDF={downloadToPDF}
                setDownloadToPDF={setDownloadToPDF}
                setLoading={setLoading}
                breLocationData={breLocationData}
                expandedRowId={expandedRowId}
                setExpandedRowId={setExpandedRowId}
                locationTableData={locationTableData}
                setLocationTableData={setLocationTableData}
                breFinancialData={breFinancialData}
                financialTableData={financialTableData}
                setFinancialTableData={setFinancialTableData}
                contentRef={contentRef}
                value={value}
                setValue={setValue}
              />
            </div>
            {downloadToPDF && selectedOuterRows?.length > 0 ? (
              <div>
                <BrePdfAllTabs
                  PDFSelectedData={PDFSelectedData}
                  downloadToPDF={downloadToPDF}
                  contentRef={contentRef}
                />
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          <div>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "700",
                fontStyle: "Bold",
                fontSize: "18px",
                padding: "20px",
              }}
            >
              Business Retention & Expansion (BRE)
            </p>
            <p
              style={{
                fontFamily: "Inter",
                fontWeight: "400",
                fontStyle: "Bold",
                fontSize: "17px",
                padding: "60px 20px 20px 20px",
                color: "#DA291C",
                lineHeight: "24px",
                textAlign:"center"
              }}
            >
              {" "}
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: "700",
                  fontStyle: "Bold",
                  fontSize: "18px",
                  color: "#DA291C",
                }}
              >
                {" "}
                Desktop View Required:
              </span>{" "}
              The features on this page are not supported on mobile devices.
              Please switch to a desktop computer for the best experience.
            </p>{" "}
          </div>
        )}
      </Layout>

      <AddToFavoriteOrgModal
        open={openCreateListmdl}
        setOpen={setOpenCreateListmdl}
        selectedOuterRows={selectedOuterRows}
        setSelectedOuterRows={setSelectedOuterRows}
        message={`Are you sure that you want to add ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to Favorites?`}
        handleApply={() => breJoiData(1)}
      />
      <LeadsProspectModal
        requestUpdateRecord={requestUpdateModal}
        setRequestUpdateRecord={setRequestUpdateModal}
        profileData={requestUpdateData}
        peopleId={selectedOuterRows?.[0]?.org_id}
        setSuccessModel={setSuccessModel}
        successModel={successModel}
        setSelectedOuterRows={setSelectedOuterRows}
      />
      <Modal
        open={successModel == true}
        onClose={() => setSuccessModel(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="vrufyerv">
          <Box sx={style} style={{ overflowY: "auto", width: "30%" }}>
            <div className="de_pad_req-up">
              <p className="cross-people-req-model">
                <ClearIcon
                  onClick={() => {
                    setSuccessModel(false);
                    setRequestUpdateData();
                  }}
                />
              </p>
              <p className="de_head">
                Your Record Update request has been successfully submitted. The
                JOI team will review your request and notify you when the record
                has been updated.
              </p>
            </div>
          </Box>
        </div>
      </Modal>
      <MessageModal
        open={messageModalTrack}
        setOpen={setMessageModalTrack}
        message={`Are you sure that you want to add ${selectedOuterRows?.length > 1 ? "these records" : "this record"} to tracking?`}
        handleSubmit={handleTrackRecords}
        length={selectedOuterRows?.length}
      />
    </>
  );
};
export default BusinessRE;

//   <Layout>
//     <div>
//   <div className="ComingSoon-outerr-container">
//     <div className="ComingSoon-inner">
//       <div className="ComingSoon-inner-heading">
//         <h3>Coming soon</h3>
//         <p className="ComingSoon-scheduled">In JOI version scheduled for April 2025</p>
//       </div>
//     </div>
//   </div>
// </div>
// </Layout>
